"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilenameNonce = void 0;
var getAlphabetNonce_1 = require("../../nanoid/getAlphabetNonce");
function getFilenameNonce() {
    return (0, getAlphabetNonce_1.getAlphabetNonce)(4);
}
exports.getFilenameNonce = getFilenameNonce;
